import { barChartHeight } from "./barChartHeight";
import renderChart from "./renderChart";

export const stackedAbsoluteChartConfig = (data, options) => {
  const { categories, series } = data;

  return {
    chart: {
      type: "bar",
      height: barChartHeight(categories.length)
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: true
    },
    xAxis: {
      categories
    },
    yAxis: {
      min: 0,
      title: {
        text: options.label,
        align: "high"
      },
      labels: {
        format: "{value}"
      },
      reversedStacks: false
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y}</b>"
    },
    plotOptions: {
      series: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y > 0 ? this.y.toFixed(0) : null;
          }
        }
      }
    },
    series
  };
};

const stackedAbsoluteChart = (element, data, options) => {
  return renderChart(element, stackedAbsoluteChartConfig(data, options), options);
};

export default stackedAbsoluteChart;
